module.exports = __webpack_public_path__ + "assets/img/07.5c1ecf15.png";